import { ActionTypes, IAction, IPageState } from './types';

export const InitialState: IPageState = {
  loading: false,
  transacoes: {
    count: 0,
    offset: 0,
    pageSize: 20,
    records: [],
  },
};

export const Reducer = (state: IPageState, action: IAction): IPageState => {
  switch (action.type) {
    case ActionTypes.UPDATE_LOADING_STATUS:
      return {
        ...state,
        loading: action.payload?.status ?? false,
      };
    case ActionTypes.UPDATE_TRANSACOES:
      return {
        ...state,
        loading: action.payload.status ?? false,
        transacoes: action.payload?.transacoes ?? {
          ...InitialState.transacoes,
        },
      };
    default:
      return { ...state };
  }
};
